import * as React from "react";
import { connect } from "react-redux";
import { Modal } from '../../ecosystem';;
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import Message from "../../carecoach/inbox/Message";

class GrantDisclaimerModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { healthrecord, pharmacy } = this.props;
        logUI(`MBHWeb.UI.GrantDisclaimerModal.ComponentDidMount`, new Date(), Tools.getURLPath(), { "healthrecord": healthrecord, "pharmacy": pharmacy });
    }

    render() {
        const { isOpen, onAgreeGrantDisclaimer, healthrecord, pharmacy, fromProxyLanding, removeBSWPharmacy } = this.props;
        const messageHeader = "By granting access to Medical Records, you understand that the person you grant access to will be able to view and request copies of all the information in your medical records, including but not limited to protected health information such as:";
        const messageFooter = "Additionally by granting access to Pharmacy, you understand that the person you grant access to may be able to determine any underlying conditions or diagnoses contained in your medical records based off of prescription information.";
        const messageBody = ["Mental records (excluding psychotherapy notes)",
            "Drug, alcohol, or substance abuse records",
            "Genetic information (including genetic test results)",
            "HIV/AIDS test results/treatment"
        ];

        if (removeBSWPharmacy) {
            messageBody.push("Prescription information");
        }

        const modalBody = <>
            <div>
                <p>{messageHeader}</p>
                <div className="col-12">
                    <ul className={"angle-bullets" + (removeBSWPharmacy ? " grant-modal" : "")}>
                        {messageBody.map((item, index) => {
                            return (<li key={index}>{item}</li>);
                        })}
                    </ul>
                </div><br />
                {!removeBSWPharmacy && <p>{messageFooter}</p>}
            </div>
        </>

        return (
            <Modal isOpen={isOpen}
                toggle={() => onAgreeGrantDisclaimer(false)}
                modalBody={modalBody}
                alignText="left"
                modalFooterButtons={[
                    {
                        label: 'Cancel',
                        onClick: () => onAgreeGrantDisclaimer(false)
                    },
                    {
                        label: 'Agree and continue',
                        onClick: () => {
                            let msg = messageHeader;
                            messageBody.map((item, index) => {
                                msg = msg + item;
                            });
                            if (removeBSWPharmacy) {
                                msg = msg + messageFooter;
                            }
                            logUI(`MBHWeb.UI.GrantDisclaimerModal.OnAgree`, new Date(), Tools.getURLPath(), { "healthrecord": healthrecord, "pharmacy": pharmacy, "disclaimer": msg, "agreed": true, "fromProxyDashboard": fromProxyLanding ? true : false });
                            onAgreeGrantDisclaimer(true);
                        }
                    }
                ]} />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};

export default connect(mapStateToProps, null)(GrantDisclaimerModal);